import { Routes } from 'lib/routes';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import CheckboxControl from './CheckboxControl';

interface Props {
    name?: string
    className?: string;
    color?: 'gray' | 'black';
}

const LicenceAgreementCheckbox: React.FC<Props> = ({
    name = 'licenceAgreement',
    className = '',
    color = 'gray',
}) => {

    const { locale } = useRouter();
    const localePrefix = useMemo(() => `/${locale}`, [locale]);

    return (
        <div className={className}>
            <CheckboxControl name={name} color={color} required>
                <Trans i18nKey="common:licenceAgreement" >
                    J’accepte de me conformer aux <a className="text-primary-500" href={localePrefix + Routes.TERMS_AND_CONDITIONS} target="_blank"> Conditions Générales </a>  de Teacher Tribe.
                </Trans>
            </CheckboxControl>
        </div>
    )
}

export default LicenceAgreementCheckbox;